export function getCardKey(cardType, cardId, location, tabIndex) {
  if (tabIndex !== undefined) {
    return `${cardType}-${cardId}-${location}-tab-${tabIndex}`;
  }
  return `${cardType}-${cardId}-${location}`;
}